<template>
  <div id="app">
    <Header />

    <Menu v-if="$route.name !== 'error404'" />

    <div class="app__wrapper" ref="main">
      <div class="app__container">

        <transition
          @enter="enter"
          @leave="leave"
          mode="in-out"
          appear
        >
          <router-view
            :key="$route.fullPath"
            :js-page="routeName"
          />
        </transition>

        <Prev />
        <Next />

        <Footer ref="footer" v-show="$route.name !== 'error404'" />

        <Info v-show="$route.name !== 'error404'"/>
      </div>
    </div>

    <div class="app__clone" ref="clone" />

    <!-- <BlobPointer /> -->
    <Pointer />

    <Cookie v-if="init" />
  </div>
</template>

<script>
// import FontFaceObserver from 'fontfaceobserver';
import { TweenMax, Expo, TimelineLite } from 'gsap/TweenMax';
import { mapGetters } from 'vuex';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import Apollo from '@adoratorio/apollo';
import Medusa from '@adoratorio/medusa';

import aion from '@/scripts/aion';
import hades from '@/scripts/hades';
import medusa from '@/scripts/medusa';
import apollo from '@/scripts/apollo';
import utils from '@/scripts/utils';

import { animations, initial, transition } from '@/assets/animations';

import Header from '@/components/ui/Header.vue';
import Menu from '@/components/ui/Menu.vue';
import Prev from '@/components/ui/Prev.vue';
import Next from '@/components/ui/Next.vue';
import Footer from '@/components/ui/Footer.vue';
import Pointer from '@/components/ui/Pointer.vue';
// import BlobPointer from '@/components/ui/BlobPointer.vue';
import Info from '@/components/ui/Info.vue';
import Cookie from '@/components/Cookie.vue';

export default {
  name: 'App',

  components: {
    Header,
    Menu,
    Footer,
    Prev,
    Next,
    Pointer,
    // BlobPointer,
    Info,
    Cookie,
  },

  data() {
    return {
      fonts: [{
        name: 'GT Sectra Fine',
        weight: 300,
      }, {
        name: 'Syne',
        weight: 700,
      }, {
        name: 'F Grotesk',
        weight: 400,
      }],

      first: true,

      velocity: 0,

      nav: {
        left: 0,
        height: 0,
        last: null,
      },

      delay: 0,
      duration: 0,
      clone: {},
      isTrans: false,
      stopped: false,
      enterEl: null,
    };
  },

  computed: {
    ...mapGetters({
      init: 'getInit',
      menu: 'getMenu',
      lang: 'getLang',
      transName: 'getTransName',
      routeName: 'getRouteName',
      goHome: 'getGoHome',
    }),
  },

  watch: {
    init(n) {
      if (n) {
        this.stopped = false;
        if (!utils.isTouchDevice()) {
          aion.add(this.linesFx, 'linesFx');
        }
      }
    },

    menu(n) {
      if (n) {
        this.openMenu();
      } else if (!this.$store.state.isTrans) {
        this.closeMenu();
      }
    },

    lang(n) {
      transition.get('menu-lang')(this.$el.querySelector('main')).play();
    },

    goHome(n) {
      const menuAnim = transition.get('menu-home')(this.$el.querySelector('main'));
      menuAnim.eventCallback('onStart', () => this.$store.commit('TOGGLE_MENUTRANS'));
      menuAnim.eventCallback('onComplete', () => { this.$store.commit('TOGGLE_MENUTRANS'); this.removeClone('menu'); this.$store.commit('SET_GOHOME', false); });
      menuAnim.play();
    }
  },

  mounted() {
    hades.init();

    medusa.init();
    this.$el.addEventListener('intesectionTriggered', e => this.check(e));

    // const observers = [];
    // this.fonts.forEach((font) => {
    //   const obs = new FontFaceObserver(font.name, { weight: font.weight });
    //   observers.push(obs.load());
    // });

    // Promise.all(observers)
    //   .then(() => {
    //     this.$store.commit('SET_INIT', true);
    //   });

    // this.$eventHub.$on('addTitleCloning', (voice) => { this.handleTitleCloning(voice); });

    this.resize();
    window.addEventListener('resize', this.resize);
  },

  beforeDestroy() {
    aion.remove('linesFx');
  },

  methods: {
    check(e) {
      e.detail.target.dataset.view = e.detail.isIntersecting;

      if (e.detail.target.dataset.view === 'true'
      && e.detail.target.parentNode.dataset.nav !== undefined
      && e.detail.target.parentNode.dataset.menu === undefined
      && e.detail.target.parentNode.dataset.project === undefined
      && e.detail.target.parentNode.dataset.clone === undefined
      && !e.detail.target.parentNode.classList.contains('next__link')
      && !e.detail.target.parentNode.classList.contains('prev__link')) {
        this.nav.last = e.detail.target.parentNode;
      }
    },


    linesFx() {
      if (!this.stopped) {
        if (hades.ref.amount.y >= (hades.ref.options.boundries.max.y - (window.innerHeight / 2))) {
          TweenMax.killTweensOf(this);
          TweenMax.to(this, 0.5, {
            velocity: 0,
            ease: Expo.easeOut,
          });
        } else {
          TweenMax.to(this, 3, {
            velocity: Math.min(hades.ref.velocity.y, 2.5),
            ease: Expo.easeOut,
          });
        }
      }

      const delta = (this.velocity * (100 / 2.5)) / 100 * 0.4;
      TweenMax.set(this.$refs.main, {
        scaleY: 1 + delta,
        transformPerspective: 1,
      });
    },

    enter(el, done) {
      this.enterEl = el;
      if (!this.first) this.enterEl.style.display = 'none';

      this.resetVelocity().then(() => {
        if (utils.isTouchDevice()) disableBodyScroll();
        hades.ref.pause();

        done();

        setTimeout(() => {
          if (this.first) {
            this.initial(document);
            this.$el.querySelector('header').style.opacity = '1';
            this.$el.querySelector('main').style.opacity = '1';
            this.$el.querySelector('footer').style.opacity = '1';
            this.$el.querySelector('.footer__info').style.opacity = '1';
          }

          if (this.transName === 'menu' || this.transName === 'siblings' || this.transName === 'siblings-prev') {
            const title = el.querySelector('[data-nav]');
            title.children[0].dataset.animated = 'true';

            this.resetFooterAnim();
            this.initial(el);
            this.stopped = false;
          }

          const duration = (this.transName === 'siblings' || this.transName === 'siblings-prev') ? this.delay / 1000 : this.duration;

          transition.get(`${this.transName}-in`)(el, duration)
          .eventCallback('onComplete', () => {
            if (!this.first &&
              !((this.transName === 'menu' || this.transName === 'siblings' || this.transName === 'siblings-prev'))) {
              this.resetFooterAnim();
              this.initial(el);

              this.stopped = false;

              this.$store.commit('SET_TRANSNAME', 'default');

              if (utils.isTouchDevice()) clearAllBodyScrollLocks();
              hades.ref.play();
              this.$store.commit('IS_TRANS', false);
            }

            if (this.transName === 'menu') {
              this.stopped = false;

              this.$store.commit('SET_TRANSNAME', 'default');

              if (utils.isTouchDevice()) clearAllBodyScrollLocks();
              hades.ref.play();
              this.$store.commit('IS_TRANS', false);
            }

            if (this.first) {
              this.stopped = false;
              this.$store.commit('IS_TRANS', false);
              if (utils.isTouchDevice()) clearAllBodyScrollLocks();
              hades.ref.play();
            }

            const els = this.first ? 
              Array.from(document.querySelectorAll('[data-anim]:not([data-animated])')) :
              [...Array.from(el.querySelectorAll('[data-anim]:not([data-animated])')),...Array.from(document.querySelectorAll('aside [data-anim]:not([data-animated])'))];
            this.checkMedusa(els);
            this.checkApollo();

            this.first = false;

          });

        }, this.delay);
      });
    },

    leave(el, done) {
      this.enterEl.style.display = 'block';
      const scrollY = hades.ref.amount.y;

      this.delay = (this.transName === 'siblings' || this.transName === 'siblings-prev') && scrollY > 0 ? 500 : 0;

      if (this.transName !== 'default') {
        this.setClone(document.querySelector(`[data-nav="${this.routeName}"]:not([data-menu])`));
      }

      const clone = this.transName !== 'menu' ? this.clone[this.routeName] : this.$el.querySelector(`[data-menu][data-nav="${this.routeName}"]`);

      const tl = transition.get(`${this.transName}-out`)(el, clone, this.routeName, this.delay / 1000);
      tl.eventCallback('onStart', () => {
        hades.ref.scrollTo({y: 0}, this.delay);
      })
      tl.eventCallback('onComplete', () => {
        if (this.transName === 'siblings' || this.transName === 'siblings-prev') {
          const title = document.querySelector(`main[js-page="${this.routeName}"] [data-siblings]`);
          const next = document.querySelector('.next__link');
          const prev = document.querySelector('.prev__link');


          this.removeClone('aside');

          this.stopped = false;

          TweenMax.set([title, next, prev], {
            autoAlpha: 1,
            display: 'block',
          });

          if (utils.isTouchDevice()) clearAllBodyScrollLocks();
          hades.ref.play();
          this.$store.commit('IS_TRANS', false);
          this.$store.commit('SET_TRANSNAME', 'default');
        }
        done();
      });

      this.duration = tl.duration();
    },

    initial(ctx = this.$el) {
      this.clone = {};
      if (this.transName === 'siblings' || this.transName === 'siblings-prev') {
        this.removeClone('main');
        } else {
        this.removeClone('all');
      }

      Array.from(ctx.querySelectorAll('[data-anim]:not([data-animated])')).forEach((element) => {
        initial.get(element.dataset.anim)(element);
      });
    },

    handleTitleCloning(voice) {
      this.clone[voice.dataNav] = this.titleCloning(voice.el);
    },

    openMenu() {
      this.setNav().then(() => {
        hades.ref.pause();
        if (utils.isTouchDevice()) disableBodyScroll(document.querySelector('nav'));
        this.removeClone('aside');

        const menuAnim = transition.get('menu-open')(this.$el.querySelector('main'), this.nav.last);
        menuAnim.eventCallback('onStart', () => this.$store.commit('TOGGLE_MENUTRANS'));
        menuAnim.eventCallback('onComplete', () => this.$store.commit('TOGGLE_MENUTRANS'));
        menuAnim.play();
      });
    },

    closeMenu() {
      hades.ref.play();
      const menuAnim = transition.get('menu-close')(this.$el.querySelector('main'), this.nav.last);
      menuAnim.eventCallback('onStart', () => this.$store.commit('TOGGLE_MENUTRANS'));
      menuAnim.eventCallback('onComplete', () => { this.$store.commit('TOGGLE_MENUTRANS'); this.removeClone('menu'); });
      menuAnim.play();
      if (utils.isTouchDevice()) clearAllBodyScrollLocks();
    },

    setNav() {
      return new Promise((resolve) => {
        const navs = Array.from(this.$el.querySelectorAll('main [data-nav]:not([data-project])'));
        const navIn = navs.filter(nav => nav.children[0].dataset.view === 'true');

        const bounding = navs[0].getBoundingClientRect();
        this.nav.left = bounding.left;
        this.nav.height = bounding.height;

        const menu = this.$el.querySelector('[role="menu"]');
        const voices = Array.from(menu.querySelectorAll('[data-nav]'));
        const extra = menu.querySelector('.extra');
        extra.style.left = `${this.nav.left}px`;

        if (navIn.length > 0 && this.$route.name !== 'project' && this.$route.name !== 'person') {
          const active = navIn[navIn.length - 1];
          const boundingNav = active.getBoundingClientRect();
          const navActive = menu.querySelector(`[data-nav="${active.dataset.nav}"]`);

          const order = parseInt(navActive.dataset.order, 10);

          voices.forEach((voice, index) => {
            let top = 0;

            if (index === order) {
              top = boundingNav.top;
            }

            if (index < order) {
              top = this.nav.height * -1;
            }

            if (index > order) {
              top = window.innerHeight;
            }

            voice.style.top = `${top}px`;

            voice.dataset.origin = voice.style.top;
            voice.style.left = `${this.nav.left}px`;
          });
        } else {
          voices.forEach((voice) => {
            voice.style.top = `${this.nav.height * -1}px`;

            voice.dataset.origin = voice.style.top;
            voice.style.left = `${this.nav.left}px`;
          });
        }

        resolve();
      });
    },

    resetVelocity() {
      return new Promise((resolve) => {
        this.stopped = true;

        TweenMax.killTweensOf(this);
        TweenMax.to(this, 0.5, {
          velocity: 0,
          ease: Expo.easeOut,
          onComplete: resolve,
        });
      });
    },

    setClone(el) {
      hades.ref.pause();
      this.velocity = 0;

      const dataNav = el.dataset.nav;
      this.clone[dataNav] = this.titleCloning(el);
    },

    titleCloning(el) {
      let title = el;

      if (this.transName === 'siblings' || this.transName === 'siblings-prev') {
        title = document.querySelector(`aside [data-nav="${this.routeName}"]`);
      }

      const dataNav = el.dataset.nav;
      const bounding = title.getBoundingClientRect();

      const clone = title.cloneNode(true);

      const role = clone.querySelector('.team__role');

      if (role !== null) role.remove();

      clone.dataset.clone = dataNav;
      clone.style.position = 'absolute';
      clone.style.top = `${bounding.top}px`;
      clone.style.left = `${bounding.left}px`;
      clone.style.display = 'none';
      clone.style.whiteSpace = 'nowrap';
      clone.children[0].dataset.animated = 'true';

      this.$refs.clone.append(clone);

      return clone;
    },

    removeClone(type) {
      if (type === 'all') {
        this.$refs.clone.innerHTML = '';
      } else if (type === 'main') {
        Array.from(this.$refs.clone.children).forEach((el) => {
          if (!el.classList.contains('prev__link') && !el.classList.contains('next__link') ) {
            el.remove();
          }
        });
      } else if (type === 'aside') {
        Array.from(this.$refs.clone.children).forEach((el) => {
          if (el.classList.contains('prev__link') || el.classList.contains('next__link') ) {
            el.remove();
          }
        });
      } else if (type === 'menu') {
        Array.from(this.$refs.clone.children).forEach((el) => {
          if (el.dataset.menu) {
            el.remove();
          }
        });
      }
    },

    resetFooterAnim() {
      const footer = this.$el.querySelector('footer');
      const animEls = Array.from(footer.querySelectorAll('[data-animated]'));
      animEls.forEach(el => el.removeAttribute('data-animated'));
    },

    resize() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    checkMedusa(els) {
      const time = this.first ? 2000 : 0;
      // const time = 0;
      setTimeout(() => {
        medusa.ref.internalTargets.forEach((target) => {
          if (target.id === 'enter-animation' || target.id === 'check-viewport') medusa.ref.removeTarget(target.id);
        });

        medusa.ref.addTarget({
          id: 'enter-animation',
          container: document.querySelector('#app'),
          nodes: els,
          mode: Medusa.MODE.ONCE,
          offsets: '0px 0px 0px 0px',
          callback: (entry) => {
            animations.get(entry.target.dataset.anim)(entry.target).play();
          },
        });

        const nodes = Array.from(document.querySelectorAll('[data-view]'));

        medusa.ref.addTarget({
          id: 'check-viewport',
          container: document.querySelector('#app'),
          nodes,
          mode: Medusa.MODE.DEFAULT,
          offsets: '100px 0px 0px 100px',
          callback: (entry) => {
          },
        });
      }, time);
    },

    checkApollo() {
      apollo.ref.removeTarget('apollo');
      apollo.ref.removeTarget('apollo-interactive');
      apollo.ref.removeTarget('apollo-magnetism');
      const target = {
        id: 'apollo',
        elements: [...Array.from(document.querySelectorAll('a:not(.logo__link)')), ...Array.from(document.querySelectorAll('.apollo__link'))],
        offset: {
          x: 0,
          y: 0,
        },
      };

      const targetInteractive = {
        id: 'apollo-interactive',
        elements: [...Array.from(document.querySelectorAll('.interactive-span'))],
        offset: {
          x: 0,
          y: 0,
        },
      };

      const targetMagnetism = {
        id: 'apollo-magnetism',
        elements: [...Array.from(document.querySelectorAll('.apollo__magnetism'))],
        offset: {
          x: 20,
          y: 20,
        },
        magnetism: {
          mode: Apollo.MODE.PULL,
          easing: {
            mode: Apollo.EASING.OUT_CUBIC,
            duration: 200,
          },
        }
      };

      apollo.ref.addTargets([target, targetInteractive, targetMagnetism]);
    }
  },
};
</script>

<style lang="scss">
@import "@/styles/base.scss";

body {
  overflow: hidden;

  @include mq($and: $is-touch-device) {
    max-width: 100vw;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
    overflow-x: hidden;
  }
}

#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  // isolation: isolate;

  @include mq($and: $is-touch-device) {
    height: auto;
  }
}

.app__wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  transform-origin: 50% 100%;
  backface-visibility: hidden;
  -webkit-filter: blur(0);
}

.app__container {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: auto;
  min-height: 100%;

  @include mq($and: $is-touch-device) {
    position: relative;
    height: auto;
  }

  display: grid;
  grid-template-columns: 0fr 1fr 0fr;
  grid-template-areas:
  'a main b'
  'a footer b';

  @include mq(ipadP) {
    grid-template-columns: 1fr 3fr 1fr;
  }

  @include mq(ds) {
    grid-template-columns: 1fr 2fr 1fr;
  }

  & > aside {
    padding: 40vh rem(20px) 0;

    @include mq(ipadP) {
      padding: 40vh rem(40px) 0;
    }

    @include mq(ds) {
      padding: 40vh rem(60px) 0;
    }
  }
}

.app__clone {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 30;
}

main {
  position: relative;
  top: 0;
  padding: 300px 25px 0px;

  @include mq(ipadP) {
    padding: 40vh 0 0;
  }

  grid-area: main;

  will-change: transform;
  backface-visibility: hidden;

  * {
    will-change: transform;
    backface-visibility: hidden;
  }
}

[data-scrollbar] {
  opacity: 1 !important;
}
</style>
